<template>
  <div class="row">
    <div class="col-lg-12">
      <!-- map -->
      <card type="card-chart" no-footer-line style="height: 75%">
        <loading
          loader="spinner"
          :height="40"
          :width="40"
          color="#00f2c3"
          background-color="#6c757d"
          transition="fade"
          :active="isLoading"
          :is-full-page="false"
        ></loading>
        <template slot="header">
          <h5 class="card-category">Location of feeder pillar and lights</h5>
          <h3 class="card-title">
            <div class="chart-area">
              <div id="map" class="map">
                <l-map
                  ref="map"
                  id="toto"
                  style="height: 75%"
                  :zoom="zoom"
                  :center="center"
                  :options="{ scrollWheelZoom: false }"
                  class="sidebar-map"
                  :bounds="devBounds"
                >
                  <l-tile-layer
                    :url="url"
                    :attribution="attribution"
                  ></l-tile-layer>
                  <l-layer-group layer-type="overlay" name="Layer 1">
                    <l-marker
                      v-for="marker in markers"
                      :lat-lng="marker.location"
                      :key="marker.addMarker"
                      ref="markersRef"
                    >
                      <l-tooltip :content="marker.deviceName" />
                    </l-marker>
                  </l-layer-group>
                  <l-layer-group layer-type="overlay" name="Layer 2">
                    <l-marker
                      v-for="marker in fpmarkers"
                      :icon="markerIcon()"
                      :key="marker.addMarker"
                      :lat-lng="marker.fploc"
                      ref="markersRef"
                    >
                      <l-tooltip :content="marker.fpName" />
                    </l-marker>
                  </l-layer-group>
                </l-map>
              </div>
            </div>
          </h3>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { Modal, BasePagination } from "src/components";
import { Table, TableColumn, Select, Option, DatePicker } from "element-ui";
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LControlSidebar,
  LTooltip,
  LLayerGroup,
} from "vue2-leaflet";
import { log } from "util";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Loading,
    BasePagination,
    Modal,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    LLayerGroup,
  },
  data() {
    return {
      isLoading: true,
      // Attributes for map
      zoom: 10,
      center: L.latLng(2.910965, 101.654385),
      url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      markers: [],
      fpmarkers: [],
      devBounds: [[L.latLng(2.910965, 101.654385)]],
      // Data for cluster
      clusters: [],
      cluster_created: "",
      fpid: "",
    };
  },
  methods: {
    setCenter(lat, long) {
      var map = this.$refs.map;
      map.setCenter(L.latLng(lat, long));
    },
    getFP() {
      this.markers = [];
      this.fpmarkers = [];
      // this.devBounds = [];
      let feederpillarID = this.$route.params.fpid;
      this.a = this.$route.params.fpid;
      console.log(feederpillarID);
      this.fpid = feederpillarID;

      this.$http
        .get(":8002/api/v1/manage/feeder/assoclights/" + this.fpid)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            for (var i = 0; i < response.length; i++) {
              let obj = {
                location: L.latLng(response[i].Latitude, response[i].Longitude),
                deviceName: response[i].DeviceName,
              };
              this.markers.push(obj);
            }

            let objfeeder = {
              fploc: L.latLng(response[0].FeederLat, response[0].FeederLon),
              fpName: response[0].FpName,
            };

            console.log(parseFloat(response[0].FeederLat));
            console.log(parseFloat(response[0].FeederLon));
            this.devBounds = []
            this.devBounds.push([
              L.latLng(response[0].FeederLat, response[0].FeederLon),
            ]);

            this.fpmarkers.push(objfeeder);
            console.log(this.devBounds);
            this.isLoading = false;
          }
        });
    },
    markerIcon() {
      return L.icon({
        iconUrl: require("@/assets/img/feeder_pillar.png"),
        iconSize: [30, 30],
        shadowUrl: require("@/assets/img/marker-shadow.png"),
        iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
        shadowAnchor: [30, 30], // the same for the shadow
        shadowSize: [30, 30],
        popupAnchor: [-3, -76],
      });
    },
  },
  created() {
    this.isLoading = true;
    this.fpid = this.$route.params.fpid;
    console.log(this.fpid);
    this.getFP();
    console.log("started");
  },
  beforeDestroy() {
    console.log("destroy");
    this.fpid = "";
    this.router.go();
  },
  watch: {
    $route() {
      this.fpid = this.$route.params.fpid;
      console.log(this.fpid);
      console.log("ha1");
      this.getFP();
    },
  },
};
</script>

<style scoped>
base-button h4 {
  display: inline;
}
.card-style {
  background-color: rgb(29, 37, 59, 0.8);
  margin-bottom: 4%;
}
.top base-button h5 {
  display: inline;
}
.btn-view {
  position: absolute;
  right: 0;
}
ul {
  height: 535px;
  list-style-type: none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 0%;
}
.cluster {
  padding-right: 10%;
  padding-left: 10%;
}
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>